module.exports = __webpack_public_path__ + "img/sx.c7e6e82b.png";